import AppFooterCopyright from "./AppFooterCopyright";

const AppFooter = () => {
  return (
    <div className="container mx-auto">
      <div className="pt-20 sm:pt-30 pb-8 border-t-2 dark:border-neutral-600 border-neutral-300">
        

        <AppFooterCopyright />
      </div>
    </div>
  );
};

export default AppFooter;
